import styled from 'styled-components';

// Lib
import {lib} from '@drivesally/sally-ui';

// Colors
const {
  colors: {white},
} = lib;

const NotLive = styled.div`
  position: absolute;
  left: 300px;
  top: 50%;
  transform: translateY(-50%);
  color: ${white};
  font-weight: 700;
  text-transform: uppercase;
  font-size: 28px;
`;

export default NotLive;
